if (typeof window.LADS === "undefined") {
    window.LADS = {};
}

// Polyfill NodeList.forEach(...)
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// Polyfill CustomEvent (IE jusqu'à 11)
(function() {
   if (typeof window.CustomEvent === "function") return false; //If not IE

   function CustomEvent (event, params) {
      params = params || { bubbles: false, cancelable: false, detail: undefined };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
   }

   CustomEvent.prototype = window.Event.prototype;

   window.CustomEvent = CustomEvent;
})();

// IE 11
if (!Object.entries) {
  Object.entries = function( obj ){
    var ownProps = Object.keys( obj ),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
    while (i--)
      resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}

function doXHR(method, url, data, callback) {
   if (!method) {
      var method = "GET";
   }

   if (!data) {
      var data = {};
   }

   var xhr = new XMLHttpRequest();
   document.body.classList.add("async-loading");

   xhr.onreadystatechange = function () {
      if (this.readyState == XMLHttpRequest.DONE) {
         document.body.classList.remove("async-loading");

         if (this.status == 200) {
            callback(this.responseText);
         }
      }
   };

   xhr.open(method, url);
   xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

   if (method === "POST" || method === "post") {
      if (data instanceof FormData) {
         xhr.send(data);
      } else {
         xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

         let urlEncodedDataPairs = [];
         for (name in data) {
            urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
         }

         // On transforme les espaces %20 en + pour coller au comportement du navigateur
         let urlEncodedData = urlEncodedDataPairs.join('&').replace(/%20/g, '+');
         xhr.send(urlEncodedData);
      }
   } else {
      xhr.send(null);
   }
}

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

function strpos(haystack, needle, offset)
{
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // *     example 1: strpos('Kevin van Zonneveld', 'e', 5);
    // *     returns 1: 14

    var i = haystack.indexOf(needle, offset); // returns -1
    return i >= 0 ? i : false;
}

function substr(f_string, f_start, f_length)
{
    // http://kevin.vanzonneveld.net
    // +     original by: Martijn Wieringa
    // *         example 1: substr('abcdef', 0, -1);
    // *         returns 1: 'abcde'

    if (f_start < 0) {
        f_start += f_string.length;
    }

    if (f_length == undefined) {
        f_length = f_string.length;
    } else if (f_length < 0) {
        f_length += f_string.length;
    } else {
        f_length += f_start;
    }

    if (f_length < f_start) {
        f_length = f_start;
    }

    return f_string.substring(f_start, f_length);
}

// Alternative to switch, functional-style
// https://codeburst.io/alternative-to-javascripts-switch-statement-with-a-functional-twist-3f572787ba1c
const match = x => ({
   on: (pred, fn) => {
      const matched = x => ({
         on: () => matched(x),
         otherwise: () => x,
      })

      if (typeof pred !== "function") {
         let value = pred;
         pred = x => x == value;
      }

      if (typeof fn !== "function") {
         let value = fn;
         fn = () => value;
      }

      return (pred(x) ? matched(fn(x)) : match(x));
   },
   otherwise: fn => {
      if (typeof fn !== "function") {
         let value = fn;
         fn = () => value;
      }

      return fn(x);
   },
})

// En attendant de remplacer ça par un meilleur système, on le met ici pour ne pas le réserver aux formulaires
function Uncheck(checks) {
   for (i = 0; i < checks.length; i++) {
      if (checks[i]) {
         var id = document.getElementById(checks[i]);
         if (id) id.checked = false;
      }
   }
}

// Debounce
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
   var timeout;
   return function () {
      var context = this, args = arguments;
      var later = () => {
         timeout = null;
         if (!immediate) {
            func.apply(context, args);
         }
      };
      var callNow = immediate && !timeout;
      window.clearTimeout(timeout);
      timeout = window.setTimeout(later, wait);
      if (callNow) {
         func.apply(context, args);
      }
   };
};

function throttle (func, delay) {
   let lastFunc;
   let lastRan;

   return function () {
      var context = this, args = arguments;
      if (!lastRan) {
         func.apply(context, args);
         lastRan = Date.now();
      } else {
         window.clearTimeout(lastFunc);
         lastFunc = window.setTimeout(() => {
            if ((Date.now() - lastRan) >= delay) {
               func.apply(context, args);
               lastRan = Date.now();
            }
         }, delay - (Date.now() - lastRan))
      }
   }
};

this.LADS = this.LADS || {};
this.LADS.Regions = {
   init: function (firstSelect) {

      var afterInit = function () {
         // Une fois que tout est initialisé, on met un listener pour que
         // le select réagisse aux changements manuels futurs
         firstSelect.addEventListener("change", function(evt) {
            window.LADS.Regions.getNext(firstSelect.dataset.regionClass, firstSelect, firstSelect.value, 1);
         });

         // Si on n'a pas de selects sous-régions, on amorce le chargement du premier sous-niveau
         if (document.querySelectorAll(
            "[data-region-class=" + firstSelect.dataset.regionClass + "]")
            .length <= 1) {
            firstSelect.dispatchEvent(new CustomEvent('change'));
         }
      };

      var params = [firstSelect.name, "selectRegion1", "selectRegion2"];

      (function check(i, select) {
         if (i < params.length) {
            var value = findGetParameter(params[i]);

            if (value) {
               select.value = value;

               window.LADS.Regions.getNext('filtre-region', select,
                     select.dataset.regionPays || select.value,
                     parseInt(select.dataset.regionNiveau, 10) + 1 || 1)
                  .then(
                     function success (newSelect) {
                        check(i+1, newSelect);
                     },
                     function nope () {
                        afterInit();
                     }
               );
            } else {
               afterInit();
            }
         }
      })(0, firstSelect);
   },

   insertSelect: function (regions, classe, select, pays, niveau, selected) {
      // Création du select
      var selectRegion = document.createElement("select");
      selectRegion.className = "select-region-" + niveau;
      selectRegion.setAttribute("data-region-class", classe);
      selectRegion.setAttribute("data-region-niveau", niveau);
      selectRegion.setAttribute("data-region-pays", pays);
      selectRegion.name = selectRegion.id = "selectRegion" + niveau;
      // Ajout d'un <option> vide
      selectRegion.appendChild(document.createElement("option"));

      // Ajout des <option>s correspondant aux régions
      var selectedOption = null;
      regions.forEach(function (v) {
         var option = document.createElement("option");
         option.value = v.CodeRegion;
         option.innerHTML = v.NomRegion;
         selectRegion.appendChild(option);
         if (typeof selected !== "undefined" && v.CodeRegion === selected) {
            option.selected = true;
         }
      });

      // Insertion du nouveau select après le select d'origine
      select.parentNode.insertBefore(selectRegion, select.nextSibling);

      // Listener sur le nouveau select pour qu'il affiche ses sous-régions
      selectRegion.addEventListener("change", function() {
         window.LADS.Regions.getNext(classe, selectRegion, pays, niveau + 1);
         window.dispatchEvent(new CustomEvent("changeSelectRegion", {detail: {
            pays: pays,
            niveau: niveau,
            region: selectRegion.options[selectRegion.selectedIndex].value,
            classe: classe
         }}));
      });

      return selectRegion;
   },

   getNext: function (classe, select, pays, niveau) {
      var url = LADS.Root + "/int-api.php?action=getRegions&niveau=" + niveau;
      if (pays) {
         url += "&pays=" + pays;
      }
      if (niveau > 1) {
         url += "&parent=" + select.options[select.selectedIndex].value;
      }

      return new Promise(function (resolve, reject) {
         doXHR("GET", url, {}, function (response) {
            var regions = JSON.parse(response);

            // Suppression des selects à remplacer
            var obsoleteSelects = select.parentElement
               .querySelectorAll("[data-region-class=" + classe + "]");

            obsoleteSelects.forEach(function (element) {
               if (element.dataset.regionNiveau >= niveau) {
                  element.parentNode.removeChild(element);
               }
            });

            if (regions.length > 0) {
               var newSelect = LADS.Regions.insertSelect(regions, classe, select, pays, niveau);
               window.dispatchEvent(new CustomEvent("loadedRegions", {detail: { class: classe, niveau: niveau }}));

               resolve(newSelect);
            } else {
               reject();
            }

            if (niveau < 2) {
               // Changement de pays : region à null (pour cacher le tr villes)
               window.dispatchEvent(new CustomEvent("changeSelectRegion", {detail: {
                  pays: pays,
                  niveau: niveau,
                  region: null
               }}));
            }
         });
      });
   },
};

window.dispatchEvent(new CustomEvent("LADSRegionsReady"));



function visionnerADS(sens) {
    var i, id_image, id_imageN, id_copyright, id_copyrightN;
    var visionneuseADS = document.getElementById('visionneuseADS');
    if (!visionneuseADS) {
        return;
    }
    nbMax = visionneuseADS.children.length;
    for (i = 1; i <= nbMax; i++)
    {
        id_image = visionneuseADS.querySelector('.image_' + i);
        if (id_image.style.display == 'block') {
            break;
        }
    }
    j = (sens) ? (i + 1) : (i - 1);
    if (j <= 0) {
        j = nbMax;
    } else if (j > nbMax) {
        j = 1;
    }
    id_imageN = visionneuseADS.querySelector('.image_' + j);
    id_image.style.display = 'none';
    id_imageN.style.display = 'block';
}


function razMRP(valeur) {
   id_SA = document.getElementById("lbSA");
   id_SA.selectedIndex = 0;

   id_S1 = document.getElementById("pmGenre");
   id_S2 = document.getElementById("pmSpectacle");
   id_SL = document.getElementById("labelSpectacles");

   id_P1 = document.getElementById("pmMetiers");
   id_P2 = document.getElementById("pmPersonne");
   id_PL = document.getElementById("labelPersonnes");

   id_O1 = document.getElementById("pmType");
   id_O2 = document.getElementById("pmOrganisme");
   id_OL = document.getElementById("labelOrganismes");
   switch (valeur) {
      case 1:
      case 11:
         if (id_O1) {
            id_O1.selectedIndex = 0;
         }
         id_O2.value = "";
         id_P1.selectedIndex = 0;
         id_P2.value = "";
         if (valeur == 11) id_S2.select();
         id_SL.classList.add("selected");
         id_PL.classList.remove("selected");
         id_OL.classList.remove("selected");
         break;
      case 2:
      case 22:
         if (id_O1) {
            id_O1.selectedIndex = 0;
         }
         id_O2.value = "";
         id_S1.selectedIndex = 0;
         id_S2.value = "";
         if (valeur == 22) id_P2.select();
         id_SL.classList.remove("selected");
         id_PL.classList.add("selected");
         id_OL.classList.remove("selected");
         break;
      case 3:
      case 33:
         id_P1.selectedIndex = 0;
         id_P2.value = "";
         id_S1.selectedIndex = 0;
         id_S2.value = "";
         if (valeur == 33) id_O2.select();
         id_SL.classList.remove("selected");
         id_PL.classList.remove("selected");
         id_OL.classList.add("selected");
         break;
   }
}

function presetPeriodeDirecteur(t) {
   pmMin = document.getElementById("pmMin");
   pmMax = document.getElementById("pmMax");
   if (t.value == 0) {
      pmMin.value = 0;
      pmMax.value = 0;
   } else {
      pmMin.value = t.value.substr(0, 4);
      pmMax.value = parseInt(t.value.substr(5), 10) - 1;
   }
}

function toggleBoitierMRP() {
   if ((d = document.getElementById("div_moteur_gauche"))) {
      d.classList.toggle("closed");
   }
}
function toggleResultatMRP() {
   if ((d = document.getElementById("div_moteur_resultat"))) {
      d.classList.toggle("closed");
   }
}
function toggleResultatWrapMRP() {
   if ((d = document.getElementById("div_moteur_resultat"))) {
      d.classList.toggle("closed");
   }
}

function focusMRP(valeur) {
   id_S2 = document.getElementById("pmSpectacle");
   id_P2 = document.getElementById("pmPersonne");
   id_O2 = document.getElementById("pmOrganisme");
   switch (valeur) {
      case 1:
         id_S2.focus();
         break;
      case 2:
         id_P2.focus();
         break;
      case 3:
         id_O2.focus();
         break;
   }
}

